import axios from "axios";

class AuthService {
  /**
   * Check if user is currently authenticated
   */
  isAuthenticated() {
    return !!localStorage.getItem("token");
  }

  /**
   * Get current access token
   */
  getAccessToken() {
    return localStorage.getItem("token");
  }

  /**
   * Get refresh token
   */
  getRefreshToken() {
    return localStorage.getItem("refresh_token");
  }

  /**
   * Get current user data
   */
  getCurrentUser() {
    const user = localStorage.getItem("user");
    return user ? JSON.parse(user) : null;
  }

  /**
   * Refresh the access token using refresh token
   */
  async refreshAccessToken() {
    const refreshToken = this.getRefreshToken();

    if (!refreshToken) {
      throw new Error("No refresh token available");
    }

    try {
      const response = await axios.post(`/token/refresh/`, {
        refresh: refreshToken,
      });

      if (response.status === 200 && response.data.access) {
        localStorage.setItem("token", response.data.access);

        // Update refresh token if provided
        if (response.data.refresh) {
          localStorage.setItem("refresh_token", response.data.refresh);
        }

        return response.data.access;
      }
    } catch (error) {
      console.error("Token refresh failed:", error);
      this.logout();
      throw error;
    }
  }

  /**
   * Logout user and clear all stored data
   */
  logout() {
    localStorage.removeItem("token");
    localStorage.removeItem("refresh_token");
    localStorage.removeItem("user");
  }

  /**
   * Store tokens and user data after login
   */
  setAuthData(user, tokens) {
    localStorage.setItem("user", JSON.stringify(user));
    localStorage.setItem("token", tokens.access);
    localStorage.setItem("refresh_token", tokens.refresh);
  }
}

export default new AuthService();
